import { Box, Button, Flex, Heading, Input } from "@chakra-ui/react";
import React from "react";
import { useState } from "react";
import { AuthContext } from "../Contexts/AuthContextProvider";

const RecipeCrud = () => {
  const [name, setName] = useState("");
  const [cuisine, setCuisine] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const { token } = React.useContext(AuthContext);

  const handleSubmit = async () => {
    const payload = {
      name,
      cuisine,
      description,
      image,
    };

    await fetch("https://dull-tan-drill-gear.cyclic.app/recipes/addrecipe", {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
      })
      .catch((e) => console.log(e));
  };

  return (
    <Flex justifyContent={"center"}>
      <Box>
        <Heading as={"h5"} size="lg" textAlign={"center"} m={"50px"}>
          Add Recipe
        </Heading>
        <Flex
          border={'1px solid black'}
          
          direction={"column"}
          gap={"20px"}
          m={"30px"}
          padding={"30px"}
          borderRadius={"20px"}
          boxShadow={"rgba(0, 0, 0, 0.35) 0px 5px 15px"}
        >
          <Input
            type={"text"}
            placeholder={"Enter Name"}
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <Input
            type={"text"}
            placeholder={"Enter Cuisine"}
            value={cuisine}
            onChange={(e) => {
              setCuisine(e.target.value);
            }}
          />
          <Input
            type={"text"}
            placeholder={"Enter description"}
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
            }}
          />
          <Input
            type={"url"}
            placeholder={"Enter Image Url"}
            value={image}
            onChange={(e) => {
              setImage(e.target.value);
            }}
          />
          <Button onClick={handleSubmit} colorScheme="teal" variant={"outline"}>
            Add Recipe
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
};

export default RecipeCrud;
